export const REFERRAL_CODE_PREFIX = 'BARMGR-'
export const REFERRAL_CODE_SUFFIX_LEN = 6

/* eslint-disable quote-props */
export const REFERRAL_REWARD_BY_CURRENCY: Record<'€' | '$' | '£', number> = {
  '€': 1800,
  '$': 1900,
  '£': 1800
}

export const REFERRAL_REWARD_NOTE = 'Recompensa por referido'
export const REFEREE_WELCOME_NOTE = 'Bono de bienvenida por referido'
// El referrer y el referee reciben el mismo valor en créditos, calculado
// con REFERRAL_REWARD_BY_CURRENCY. El trial inicial es DEFAULT_TRIAL_DAYS
// para todos los usuarios (con o sin código de referido).
export const DEFAULT_TRIAL_DAYS = 30
export const CREDIT_EXPIRY_DAYS = 365
export const MAX_REFERRALS_PER_YEAR_PER_BAR = 50

export const STRIPE_CURRENCY_BY_SYMBOL: Record<'€' | '$' | '£', 'eur' | 'usd' | 'gbp'> = {
  '€': 'eur',
  '$': 'usd',
  '£': 'gbp'
}
/* eslint-enable quote-props */

/**
 * Builds the shareable referral link for a code. The system is link-based
 * (the `?ref=` param is picked up by AdsSourceTracker); codes are only the
 * payload embedded in the link, not something users type anywhere.
 */
export function buildReferralLink (code: string): string {
  const baseUrl = process.env.NODE_ENV === 'production'
    ? 'https://www.barmanager.app'
    : 'http://localhost:3000'
  return `${baseUrl}/?ref=${code}`
}

/**
 * Formats the credit reward for a given currency in the compact "18€" /
 * "19$" / "18£" shape used in marketing copy. Whole-number amounts render
 * without decimals; non-integer amounts (none today, future-proof) render
 * with two decimals.
 */
export function formatCreditReward (currency: '€' | '$' | '£'): string {
  const cents = REFERRAL_REWARD_BY_CURRENCY[currency]
  const value = cents / 100
  return `${Number.isInteger(value) ? value : value.toFixed(2)}${currency}`
}

/**
 * Formats the credit reward in the "hasta 1800€" / "up to 1900$" shape used
 * in marketing headlines. Renders the cents value as the main unit so the
 * number is more visually impactful. The actual amount of credit is
 * `formatCreditReward(currency)` — this is purely a presentation choice.
 */
export function formatCreditRewardMax (currency: '€' | '$' | '£'): string {
  return `${REFERRAL_REWARD_BY_CURRENCY[currency]}${currency}`
}
